import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const usePortfoliosPracticesAccessStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflow: "auto",
    paddingLeft: designTokens.spacing[8],
    paddingRight: designTokens.spacing[8],
  },

  tabBar: {
    marginBottom: designTokens.spacing[1],
  },

  tabContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    paddingLeft: designTokens.spacing[4],
    paddingRight: designTokens.spacing[8],
  },

  errorAlert: {
    padding: designTokens.spacing[3],
    backgroundColor: projectIqTokens.rustBg,
    color: projectIqTokens.rust,
    borderRadius: designTokens.borderRadius.md,
    marginBottom: designTokens.spacing[4],
  },

  dialogField: {
    marginBottom: designTokens.spacing[4],
  },
});
